import React from 'react';
import { Button } from './Button';
export function FinalPurchaseSection() {
  return <section className="py-8 md:py-14 px-3 bg-brand-card border-y-2 border-brand-accent relative overflow-hidden" data-id="element-47">
      {/* Soft background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[80%] h-[80%] bg-brand-accent/10 blur-[100px] rounded-full pointer-events-none" data-id="element-48"></div>

      <div className="max-w-3xl mx-auto relative z-10" data-id="element-49">
        <div className="text-center mb-7" data-id="element-50">
          <h2 className="text-2xl md:text-5xl font-black text-white uppercase tracking-tight mb-2" data-id="element-51">
            🎉 ÚLTIMA OPORTUNIDAD
          </h2>
          <p className="text-xs md:text-base text-gray-400 font-bold uppercase tracking-widest" data-id="element-52">
            No dejes pasar esta oferta
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 max-w-4xl mx-auto" data-id="element-53">
          {/* Offer 1 */}
          <div className="relative rounded-xl p-[2px] bg-gradient-to-br from-brand-accent via-brand-neon to-brand-accentDark shadow-[0_0_25px_rgba(212,161,75,0.3)]" data-id="element-54">
            <div className="bg-brand-dark rounded-xl p-4 md:p-6 flex flex-col h-full" data-id="element-55">
              <div className="text-center mb-4 border-b border-white/10 pb-4" data-id="element-56">
                <h3 className="text-sm md:text-lg font-black text-brand-neon mb-1 uppercase tracking-widest" data-id="element-57">
                  ⚡ OFERTA #1
                </h3>
                <h4 className="text-lg md:text-2xl font-black text-white uppercase leading-tight" data-id="element-58">
                  MEGA PACK HERRERÍA MODERNA
                </h4>
              </div>

              <div className="text-center mb-5 flex-grow flex flex-col justify-end" data-id="element-59">
                <p className="text-sm md:text-lg text-gray-500 line-through font-black mb-1" data-id="element-60">
                  Antes $49.900 ARS
                </p>
                <p className="text-2xl md:text-4xl font-black text-white leading-tight" data-id="element-61">
                  🔥 HOY SOLO
                  <br data-id="element-62" />
                  <span className="text-brand-neon" data-id="element-63">$19.990 ARS</span>
                </p>
              </div>

              <Button href="https://checkout.kitonline.shop/cart/48058660487406:1" className="py-3 text-sm md:text-lg w-full" pulse={false} data-id="element-64">
                QUIERO EL MEGA PACK
              </Button>
            </div>
          </div>

          {/* Offer 2 - Most chosen - Flashy animated border */}
          <div className="relative rounded-xl p-[3px] shadow-[0_0_40px_rgba(212,161,75,0.4)] md:-translate-y-3 animate-[shimmer_3s_linear_infinite]" style={{
          background: 'linear-gradient(135deg, #F0C674 0%, #D4A14B 25%, #A8782C 50%, #D4A14B 75%, #F0C674 100%)',
          backgroundSize: '200% 200%'
        }} data-id="element-65">
            <div className="bg-brand-dark rounded-xl p-4 md:p-6 flex flex-col h-full relative" data-id="element-66">
              <div className="absolute -top-3.5 left-1/2 transform -translate-x-1/2 bg-brand-accent text-brand-dark font-black px-4 py-1 rounded-full text-[10px] md:text-xs tracking-widest shadow-xl whitespace-nowrap uppercase border-2 border-brand-dark" data-id="element-67">
                🏆 MÁS ELEGIDA
              </div>

              <div className="text-center mb-4 border-b border-white/10 pb-4 mt-2" data-id="element-68">
                <h3 className="text-sm md:text-lg font-black text-brand-neon mb-1 uppercase tracking-widest" data-id="element-69">
                  ⚡ OFERTA #2
                </h3>
                <h4 className="text-lg md:text-2xl font-black text-white uppercase leading-tight" data-id="element-70">
                  SISTEMA PROFESIONAL DE FABRICACIÓN INDUSTRIAL
                </h4>
              </div>

              <div className="text-center mb-5 flex-grow flex flex-col justify-end" data-id="element-71">
                <p className="text-sm md:text-lg text-gray-500 line-through font-black mb-1" data-id="element-72">
                  Antes $79.900 ARS
                </p>
                <p className="text-2xl md:text-4xl font-black text-white leading-tight" data-id="element-73">
                  🔥 HOY SOLO
                  <br data-id="element-74" />
                  <span className="text-brand-neon" data-id="element-75">$27.990 ARS</span>
                </p>
              </div>

              <Button href="https://checkout.kitonline.shop/cart/48058662715630:1" className="py-3 md:py-4 text-sm md:text-xl w-full" pulse={true} data-id="element-76">
                QUIERO EL SISTEMA COMPLETO
              </Button>
            </div>
          </div>
        </div>
      </div>

      <style data-id="element-77">{`
        @keyframes shimmer {
          0% { background-position: 0% 50%; }
          50% { background-position: 100% 50%; }
          100% { background-position: 0% 50%; }
        }
      `}</style>
    </section>;
}